import React, { Component } from 'react';
import { connect } from 'react-redux';
import Translation from '../../utilities/localizationUtility';

class Index extends Component {
  render() {
    const { totalPrice, price, settings, style } = this.props,
          t = new Translation(settings),
          fontSize = style && style.fontSize ? `calc(${style.fontSize} * 1.2)` : 'inherit',
          value = price || totalPrice;

    return(
      <p className="text-right" style={{fontSize: fontSize}}>
        {this.props.title}:
        <span className="ml10">
          {t.key('priceSymbol')}
          {(+value).toFixed(2)}
        </span>
      </p>
    )
  }
}

export default connect(({ order, settings }) => ({
  settings,
  totalPrice: (+order.totalPrice || 0) * (order.quantity || 1),
}))(Index);
